import axios from "axios";
import { firmOnboardingUrl, getLocationAndPincodeUrl, onboardCompanyRoleUrl, RoleAdditionUrl } from "../urls";
import { getTokenHeader, getToken } from "../../../../screen/auth/action";

export const onboardCompanyRoleAction = async (selectedFirmId) => {
  return new Promise(async (next) => {
    let params = {};
    if (selectedFirmId) {
      params.firm_id = selectedFirmId;
    }
    let token = await getToken();
    await axios
      .get(onboardCompanyRoleUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};

export const getLocationAndPincodeAction = async (id, params = {}) => {
  return new Promise(async (next) => {
    await axios
      .get(`${getLocationAndPincodeUrl()}?district_id=${id}`, { params })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const firmOnboardingAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken(); 
    await axios
      .post(
        `${firmOnboardingUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      }) 
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};
export const RoleAddtionAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken(); 
    await axios
      .post(
        `${RoleAdditionUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      }) 
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};